'use client';
import dynamic from 'next/dynamic';
import { Suspense } from 'react';

import { GRID_ITEMS_PER_REQUEST } from '~constants/grid';
import { GridItemSkeleton } from '~entities/grid';
import { GridWrapper } from '~entities/grid/ui/GridWrapper';

const PersonalGridInner = dynamic(
	() =>
		import('./PersonalGridInner').then((module) => module.PersonalGridInner),
	{
		ssr: false,
		loading: () => (
			<GridWrapper key="grid-wrapper">
				{Array.from({ length: GRID_ITEMS_PER_REQUEST }).map((_, i) => (
					<GridItemSkeleton key={i} />
				))}
			</GridWrapper>
		),
	}
);

export const PersonalGrid = () => (
	<Suspense>
		<PersonalGridInner />
	</Suspense>
);
